import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();

  // Check if we're on pages that should have dark footer (matching dark navbar pages)
  const isDarkPage = ['/', '/login', '/register', '/contact', '/use-case', '/about', '/privacy', '/terms', '/products/vehicle-history', '/products/dmv-records', '/products/vin-decode', '/products/theft-lien-check'].includes(location.pathname);

  return (
    <footer className={`relative z-10 mt-16 border-t backdrop-blur-sm ${
      isDarkPage
        ? 'border-white/10 bg-black/40'
        : 'border-black/[0.06] bg-white/40'
    }`}>
      <div className={`max-w-7xl mx-auto px-4 md:px-8 py-6 ${!isDarkPage ? 'lg:ml-[220px]' : ''}`}>
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <div className={`text-sm text-center md:text-left ${isDarkPage ? 'text-slate-400' : 'text-[#64748b]'}`}>
            © 2025 Auto Access Solutions. All rights reserved.
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link
              to="/terms"
              target="_blank"
              rel="noopener noreferrer"
              className={`transition-colors no-underline ${
                isDarkPage
                  ? 'text-slate-400 hover:text-white'
                  : 'text-[#64748b] hover:text-[#0f172a]'
              }`}
            >
              Terms & Conditions
            </Link>
            <Link
              to="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className={`transition-colors no-underline ${
                isDarkPage
                  ? 'text-slate-400 hover:text-white'
                  : 'text-[#64748b] hover:text-[#0f172a]'
              }`}
            >
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
